import { render } from "./QuickEditCourse.vue?vue&type=template&id=307a72e5&scoped=true"
import script from "./QuickEditCourse.vue?vue&type=script&lang=js"
export * from "./QuickEditCourse.vue?vue&type=script&lang=js"

import "./QuickEditCourse.vue?vue&type=style&index=0&id=307a72e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307a72e5"]])

export default __exports__